export { InlinePromptEditor } from "./inline-prompt-editor";
export type {
  InlinePromptValue,
  InlinePromptEditorProps,
} from "./inline-prompt-editor";
